import React, { useEffect, useState } from "react";
import { Accordion } from "react-bootstrap";

interface AboutAccordianType {
  type: string;
  details: Array<object>;
}

const AboutAccordian: React.FC<AboutAccordianType> = ({ type, details }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (details.length > 0) {
      const tempItems = details.filter((item) => item.type === type);

      setItems(tempItems || []);
    }
  }, [details]);
  return (
    <div className="accordion-wrapper">
      {items.length === 0 && <div className=""></div>}

      {items.length > 0 && (
        <Accordion defaultActiveKey="0">
          {items.map((item) => (
            <Accordion.Item key={`${type}-${item.id}`} eventKey={`${item.id}`}>
              <Accordion.Header>
                {/* <img src={aboutFoodsIcon} alt="" /> */}
                {item.heading}
              </Accordion.Header>

              <Accordion.Body>
                <div className="accordion-body-list m-0">
                  <div
                    className="accordion-list-item m-0"
                    dangerouslySetInnerHTML={{ __html: item.content }}
                  />
                </div>
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      )}
    </div>
  );
};

export default AboutAccordian;
